import moment from 'moment-timezone';

export const getTimezoneOptions = (): { label: string; value: string }[] =>
  moment.tz.names().map((name) => ({ label: name, value: name }));
